import { render, staticRenderFns } from "./BloomProfilePreview.vue?vue&type=template&id=127229af&scoped=true&"
import script from "./BloomProfilePreview.vue?vue&type=script&lang=js&"
export * from "./BloomProfilePreview.vue?vue&type=script&lang=js&"
import style0 from "./BloomProfilePreview.vue?vue&type=style&index=0&id=127229af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127229af",
  null
  
)

export default component.exports